export enum ProgressTags {
  PRIMARY = 'primary',
  COMPLETED = 'completed',
}
